import { createApp } from 'vue'
import vuetify from '@/plugins/vuetify'
import MaintenanceView from '@/views/MaintenanceView.vue'
import { isMaintenanceModeOn, getMaintenanceModeBypassCode } from '@/global/environmentGetters'

export class MaintenanceGuardService {
  static shouldDisplayMaintenancePage(): boolean {
    const urlParams = new URLSearchParams(window.location.search)
    const bypassKey = urlParams.get('bypass')

    const maintenanceModeOn = isMaintenanceModeOn()
    const bypassCode = getMaintenanceModeBypassCode()

    if (maintenanceModeOn) {
      return bypassKey !== bypassCode
    } else {
      return false
    }
  }

  static showMaintenance() {
    const app = createApp(MaintenanceView)
    app.use(vuetify)
    app.mount('#app')
  }
}
